const initialState = {
  users: null,
  loading: false,
  totalItems: 0,
  totalPages: 0,
  Exam_id: null,
  searchVal: null,
  userAnswers: null,
  Paper_id: null,
};

const examUserReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "SHOW_EXAM_USERS": {
      return {
        ...state,
        users: actions.users,
        loading: actions.loading,
        // totalPages:Math.round(actions.data.count > 20??20/20),
        currentPage: actions.currentPage,
        Exam_id: actions.Exam_id,
        ...actions.data,
      };
    }

    case "RESET_DATA": {
      return { ...state, users: [], totalItems: "", totalPages: "" };
    }
    case "CLEAR_DATA": {
      return {
        ...state,
        users: [],
        totalItems: "",
        totalPages: "",
        data: null,
        count: 0,
        Exam_id: null,
      };
    }
    case "Loading": {
      return { ...state, loading: true };
    }
    case "USER_ANSWER_DATA": {
      return {
        ...state,
        userAnswers: actions.payload,
      };
    }
    case "UPDATE_PAPERID": {
      return {
        ...state,
        Paper_id: actions.payload,
      };
    }
    case "ADD_SEARCH_VAL": {
      return {
        ...state,
        searchVal: actions.data,
      };
    }
    default:
      return state;
  }
};
export default examUserReducer;
